import { Injectable } from '@angular/core';
import { DefaultCoursesQuestionsService } from './default-courses-questions.service';
import { QuestionBase, QuestionGroup } from 'core/components/forms';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'core/services';

@Injectable({
  providedIn: 'root'
})
export class CsCoursesQuestionsService extends DefaultCoursesQuestionsService {
  constructor(protected translateService: TranslateService, protected profileService: ProfileService) {
    super(translateService, profileService);
  }
  public createSpecificQuestions(params: any = {}): QuestionBase<any>[] {
    return [this.getCsCourseConfigGroup(params)];
  }

  /**
   * Get the Object for the CS form
   * @param params
   * @returns the course config for CS
   */
  private getCsCourseConfigGroup(params: any): QuestionGroup {
    const csCourseConfigGroup: QuestionGroup = new QuestionGroup({
      key: 'courseConfigIds',
      title: 'courses.config.title',
      isSection: false,
      hasHtml: true,
      childQuestions: [this.getDiplomaQuestion(params), this.getAccessModeQuestion(params)]
        .filter((question) => question != null)
        .sort((a, b) => a.order - b.order)
    });

    return csCourseConfigGroup;
  }
}
